export class CacheHelper {
    private static readonly cache: Map<string, any> = new Map();

    static set(key: string, value: any): boolean {
        try {
            CacheHelper.cache.set(key, value);
            return true;
        } catch (error) {
            return false;
        }
    }

    static get(key: string): any {
        try {
            return CacheHelper.cache.get(key);
        } catch (error) {
            return undefined;
        }
    }

    static remove(key: string): void {
        try {
            CacheHelper.cache.delete(key);
        } catch (error) { }
    }
}